module.exports = __webpack_public_path__ + "static/media/product-bg3.4e287ff2.png";